/* eslint-disable */
// @generated by protobuf-ts 2.8.2 with parameter add_pb_suffix,use_proto_field_name,ts_nocheck,eslint_disable
// @generated from protobuf file "brandguard.feedback.proto" (package "brandguardfeedback", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.FeedbackItem
 */
export interface FeedbackItem {
    /**
     * @generated from protobuf field: brandguardfeedback.Category category = 1;
     */
    category: Category;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string severity = 3;
     */
    severity: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: string recommendation = 5;
     */
    recommendation: string;
    /**
     * @generated from protobuf field: string location = 6;
     */
    location: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.EmailOptions
 */
export interface EmailOptions {
    /**
     * @generated from protobuf field: string recipient_email = 1 [json_name = "recipient_email"];
     */
    recipient_email: string;
    /**
     * @generated from protobuf field: string subject = 2;
     */
    subject: string;
    /**
     * @generated from protobuf field: string message = 3;
     */
    message: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.SubmitRequest
 */
export interface SubmitRequest {
    /**
     * @generated from protobuf field: string event_type = 1 [json_name = "event_type"];
     */
    event_type: string;
    /**
     * @generated from protobuf field: repeated string event_ids = 2 [json_name = "event_ids"];
     */
    event_ids: string[];
    /**
     * @generated from protobuf field: repeated string selected_types = 3 [json_name = "selected_types"];
     */
    selected_types: string[];
    /**
     * @generated from protobuf field: string comment = 4;
     */
    comment: string;
    /**
     * @generated from protobuf field: string client_action = 5 [json_name = "client_action"];
     */
    client_action: string;
    /**
     * @generated from protobuf field: brandguardfeedback.EmailOptions email = 6;
     */
    email?: EmailOptions;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.SubmitResponse
 */
export interface SubmitResponse {
    /**
     * @generated from protobuf field: string submission_id = 1 [json_name = "submission_id"];
     */
    submission_id: string;
    /**
     * @generated from protobuf field: repeated brandguardfeedback.FeedbackItem items = 2;
     */
    items: FeedbackItem[];
    /**
     * @generated from protobuf field: string formatted_markdown = 3 [json_name = "formatted_markdown"];
     */
    formatted_markdown: string;
    /**
     * @generated from protobuf field: int32 total_issues = 4 [json_name = "total_issues"];
     */
    total_issues: number;
    /**
     * @generated from protobuf field: int32 error_count = 5 [json_name = "error_count"];
     */
    error_count: number;
    /**
     * @generated from protobuf field: int32 warning_count = 6 [json_name = "warning_count"];
     */
    warning_count: number;
    /**
     * @generated from protobuf field: int32 events_processed = 7 [json_name = "events_processed"];
     */
    events_processed: number;
    /**
     * @generated from protobuf field: int32 events_with_items = 8 [json_name = "events_with_items"];
     */
    events_with_items: number;
    /**
     * @generated from protobuf field: bool email_sent = 9 [json_name = "email_sent"];
     */
    email_sent: boolean;
    /**
     * @generated from protobuf field: string email_error = 10 [json_name = "email_error"];
     */
    email_error: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.PreviewResponse
 */
export interface PreviewResponse {
    /**
     * @generated from protobuf field: repeated brandguardfeedback.FeedbackItem items = 1;
     */
    items: FeedbackItem[];
    /**
     * @generated from protobuf field: int32 total_issues = 2 [json_name = "total_issues"];
     */
    total_issues: number;
    /**
     * @generated from protobuf field: int32 error_count = 3 [json_name = "error_count"];
     */
    error_count: number;
    /**
     * @generated from protobuf field: int32 warning_count = 4 [json_name = "warning_count"];
     */
    warning_count: number;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.FeedbackLogEntry
 */
export interface FeedbackLogEntry {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string submission_id = 2 [json_name = "submission_id"];
     */
    submission_id: string;
    /**
     * @generated from protobuf field: string event_id = 3 [json_name = "event_id"];
     */
    event_id: string;
    /**
     * @generated from protobuf field: string event_type = 4 [json_name = "event_type"];
     */
    event_type: string;
    /**
     * @generated from protobuf field: brandguardfeedback.ModelType type = 5;
     */
    type: ModelType;
    /**
     * @generated from protobuf field: string severity = 6;
     */
    severity: string;
    /**
     * @generated from protobuf field: string item_description = 7 [json_name = "item_description"];
     */
    item_description: string;
    /**
     * @generated from protobuf field: string created_at = 8 [json_name = "created_at"];
     */
    created_at: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.FeedbackHistoryItem
 */
export interface FeedbackHistoryItem {
    /**
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * @generated from protobuf field: string severity = 2;
     */
    severity: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.FeedbackHistorySubmission
 */
export interface FeedbackHistorySubmission {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string event_type = 2 [json_name = "event_type"];
     */
    event_type: string;
    /**
     * @generated from protobuf field: string client_action = 3 [json_name = "client_action"];
     */
    client_action: string;
    /**
     * @generated from protobuf field: string comment = 4;
     */
    comment: string;
    /**
     * @generated from protobuf field: string submitter_id = 5 [json_name = "submitter_id"];
     */
    submitter_id: string;
    /**
     * @generated from protobuf field: string submitter_display = 6 [json_name = "submitter_display"];
     */
    submitter_display: string;
    /**
     * @generated from protobuf field: string submitter_email = 7 [json_name = "submitter_email"];
     */
    submitter_email: string;
    /**
     * @generated from protobuf field: string created_at = 8 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: bool email_sent = 9 [json_name = "email_sent"];
     */
    email_sent: boolean;
    /**
     * @generated from protobuf field: string email_error = 10 [json_name = "email_error"];
     */
    email_error: string;
    /**
     * @generated from protobuf field: repeated brandguardfeedback.FeedbackHistoryItem items = 11;
     */
    items: FeedbackHistoryItem[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.FeedbackHistoryResponse
 */
export interface FeedbackHistoryResponse {
    /**
     * @generated from protobuf field: repeated brandguardfeedback.FeedbackHistorySubmission submissions = 1;
     */
    submissions: FeedbackHistorySubmission[];
}
/**
 * @generated from protobuf enum brandguardfeedback.Category
 */
export enum Category {
    /**
     * @generated from protobuf enum value: CATEGORY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CATEGORY_CONTENT_SAFETY = 1;
     */
    CONTENT_SAFETY = 1,
    /**
     * @generated from protobuf enum value: CATEGORY_CONTENT_QUALITY = 2;
     */
    CONTENT_QUALITY = 2
}
/**
 * @generated from protobuf enum brandguardfeedback.ModelType
 */
export enum ModelType {
    /**
     * @generated from protobuf enum value: MODEL_UNKNOWN = 0;
     */
    MODEL_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: MODEL_LOOK_AND_FEEL = 1;
     */
    MODEL_LOOK_AND_FEEL = 1,
    /**
     * @generated from protobuf enum value: MODEL_BRAND_CONSISTENCY = 2;
     */
    MODEL_BRAND_CONSISTENCY = 2,
    /**
     * @generated from protobuf enum value: MODEL_CORRECT_LOGOS = 3;
     */
    MODEL_CORRECT_LOGOS = 3,
    /**
     * @generated from protobuf enum value: MODEL_CORRECT_FONTS = 4;
     */
    MODEL_CORRECT_FONTS = 4,
    /**
     * @generated from protobuf enum value: MODEL_BRAND_COLORS = 5;
     */
    MODEL_BRAND_COLORS = 5,
    /**
     * @generated from protobuf enum value: MODEL_NUDITY = 6;
     */
    MODEL_NUDITY = 6,
    /**
     * @generated from protobuf enum value: MODEL_VIOLENCE = 7;
     */
    MODEL_VIOLENCE = 7,
    /**
     * @generated from protobuf enum value: MODEL_TEXT_CONSISTENCY = 8;
     */
    MODEL_TEXT_CONSISTENCY = 8,
    /**
     * @generated from protobuf enum value: MODEL_TONE_AND_VOICE = 9;
     */
    MODEL_TONE_AND_VOICE = 9,
    /**
     * @generated from protobuf enum value: MODEL_RACISM = 10;
     */
    MODEL_RACISM = 10,
    /**
     * @generated from protobuf enum value: MODEL_PROFANITY = 11;
     */
    MODEL_PROFANITY = 11,
    /**
     * @generated from protobuf enum value: MODEL_GRAMMAR = 12;
     */
    MODEL_GRAMMAR = 12,
    /**
     * @generated from protobuf enum value: MODEL_REFERENCE_RULES = 13;
     */
    MODEL_REFERENCE_RULES = 13
}
// @generated message type with reflection information, may provide speed optimized methods
class FeedbackItem$Type extends MessageType<FeedbackItem> {
    constructor() {
        super("brandguardfeedback.FeedbackItem", [
            { no: 1, name: "category", kind: "enum", T: () => ["brandguardfeedback.Category", Category, "CATEGORY_"] },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "severity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "recommendation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FeedbackItem>): FeedbackItem {
        const message = { category: 0, type: "", severity: "", description: "", recommendation: "", location: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedbackItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedbackItem): FeedbackItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguardfeedback.Category category */ 1:
                    message.category = reader.int32();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string severity */ 3:
                    message.severity = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string recommendation */ 5:
                    message.recommendation = reader.string();
                    break;
                case /* string location */ 6:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedbackItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguardfeedback.Category category = 1; */
        if (message.category !== 0)
            writer.tag(1, WireType.Varint).int32(message.category);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string severity = 3; */
        if (message.severity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.severity);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string recommendation = 5; */
        if (message.recommendation !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.recommendation);
        /* string location = 6; */
        if (message.location !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.FeedbackItem
 */
export const FeedbackItem = new FeedbackItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailOptions$Type extends MessageType<EmailOptions> {
    constructor() {
        super("brandguardfeedback.EmailOptions", [
            { no: 1, name: "recipient_email", kind: "scalar", localName: "recipient_email", jsonName: "recipient_email", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailOptions>): EmailOptions {
        const message = { recipient_email: "", subject: "", message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EmailOptions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailOptions): EmailOptions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string recipient_email = 1 [json_name = "recipient_email"];*/ 1:
                    message.recipient_email = reader.string();
                    break;
                case /* string subject */ 2:
                    message.subject = reader.string();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailOptions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string recipient_email = 1 [json_name = "recipient_email"]; */
        if (message.recipient_email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.recipient_email);
        /* string subject = 2; */
        if (message.subject !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subject);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.EmailOptions
 */
export const EmailOptions = new EmailOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitRequest$Type extends MessageType<SubmitRequest> {
    constructor() {
        super("brandguardfeedback.SubmitRequest", [
            { no: 1, name: "event_type", kind: "scalar", localName: "event_type", jsonName: "event_type", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_ids", kind: "scalar", localName: "event_ids", jsonName: "event_ids", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "selected_types", kind: "scalar", localName: "selected_types", jsonName: "selected_types", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "client_action", kind: "scalar", localName: "client_action", jsonName: "client_action", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "email", kind: "message", T: () => EmailOptions }
        ]);
    }
    create(value?: PartialMessage<SubmitRequest>): SubmitRequest {
        const message = { event_type: "", event_ids: [], selected_types: [], comment: "", client_action: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SubmitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmitRequest): SubmitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_type = 1 [json_name = "event_type"];*/ 1:
                    message.event_type = reader.string();
                    break;
                case /* repeated string event_ids = 2 [json_name = "event_ids"];*/ 2:
                    message.event_ids.push(reader.string());
                    break;
                case /* repeated string selected_types = 3 [json_name = "selected_types"];*/ 3:
                    message.selected_types.push(reader.string());
                    break;
                case /* string comment */ 4:
                    message.comment = reader.string();
                    break;
                case /* string client_action = 5 [json_name = "client_action"];*/ 5:
                    message.client_action = reader.string();
                    break;
                case /* brandguardfeedback.EmailOptions email */ 6:
                    message.email = EmailOptions.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_type = 1 [json_name = "event_type"]; */
        if (message.event_type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.event_type);
        /* repeated string event_ids = 2 [json_name = "event_ids"]; */
        for (let i = 0; i < message.event_ids.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.event_ids[i]);
        /* repeated string selected_types = 3 [json_name = "selected_types"]; */
        for (let i = 0; i < message.selected_types.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.selected_types[i]);
        /* string comment = 4; */
        if (message.comment !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.comment);
        /* string client_action = 5 [json_name = "client_action"]; */
        if (message.client_action !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.client_action);
        /* brandguardfeedback.EmailOptions email = 6; */
        if (message.email)
            EmailOptions.internalBinaryWrite(message.email, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.SubmitRequest
 */
export const SubmitRequest = new SubmitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitResponse$Type extends MessageType<SubmitResponse> {
    constructor() {
        super("brandguardfeedback.SubmitResponse", [
            { no: 1, name: "submission_id", kind: "scalar", localName: "submission_id", jsonName: "submission_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FeedbackItem },
            { no: 3, name: "formatted_markdown", kind: "scalar", localName: "formatted_markdown", jsonName: "formatted_markdown", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_issues", kind: "scalar", localName: "total_issues", jsonName: "total_issues", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "error_count", kind: "scalar", localName: "error_count", jsonName: "error_count", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "warning_count", kind: "scalar", localName: "warning_count", jsonName: "warning_count", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "events_processed", kind: "scalar", localName: "events_processed", jsonName: "events_processed", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "events_with_items", kind: "scalar", localName: "events_with_items", jsonName: "events_with_items", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "email_sent", kind: "scalar", localName: "email_sent", jsonName: "email_sent", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "email_error", kind: "scalar", localName: "email_error", jsonName: "email_error", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SubmitResponse>): SubmitResponse {
        const message = { submission_id: "", items: [], formatted_markdown: "", total_issues: 0, error_count: 0, warning_count: 0, events_processed: 0, events_with_items: 0, email_sent: false, email_error: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SubmitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmitResponse): SubmitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string submission_id = 1 [json_name = "submission_id"];*/ 1:
                    message.submission_id = reader.string();
                    break;
                case /* repeated brandguardfeedback.FeedbackItem items */ 2:
                    message.items.push(FeedbackItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string formatted_markdown = 3 [json_name = "formatted_markdown"];*/ 3:
                    message.formatted_markdown = reader.string();
                    break;
                case /* int32 total_issues = 4 [json_name = "total_issues"];*/ 4:
                    message.total_issues = reader.int32();
                    break;
                case /* int32 error_count = 5 [json_name = "error_count"];*/ 5:
                    message.error_count = reader.int32();
                    break;
                case /* int32 warning_count = 6 [json_name = "warning_count"];*/ 6:
                    message.warning_count = reader.int32();
                    break;
                case /* int32 events_processed = 7 [json_name = "events_processed"];*/ 7:
                    message.events_processed = reader.int32();
                    break;
                case /* int32 events_with_items = 8 [json_name = "events_with_items"];*/ 8:
                    message.events_with_items = reader.int32();
                    break;
                case /* bool email_sent = 9 [json_name = "email_sent"];*/ 9:
                    message.email_sent = reader.bool();
                    break;
                case /* string email_error = 10 [json_name = "email_error"];*/ 10:
                    message.email_error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string submission_id = 1 [json_name = "submission_id"]; */
        if (message.submission_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.submission_id);
        /* repeated brandguardfeedback.FeedbackItem items = 2; */
        for (let i = 0; i < message.items.length; i++)
            FeedbackItem.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string formatted_markdown = 3 [json_name = "formatted_markdown"]; */
        if (message.formatted_markdown !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.formatted_markdown);
        /* int32 total_issues = 4 [json_name = "total_issues"]; */
        if (message.total_issues !== 0)
            writer.tag(4, WireType.Varint).int32(message.total_issues);
        /* int32 error_count = 5 [json_name = "error_count"]; */
        if (message.error_count !== 0)
            writer.tag(5, WireType.Varint).int32(message.error_count);
        /* int32 warning_count = 6 [json_name = "warning_count"]; */
        if (message.warning_count !== 0)
            writer.tag(6, WireType.Varint).int32(message.warning_count);
        /* int32 events_processed = 7 [json_name = "events_processed"]; */
        if (message.events_processed !== 0)
            writer.tag(7, WireType.Varint).int32(message.events_processed);
        /* int32 events_with_items = 8 [json_name = "events_with_items"]; */
        if (message.events_with_items !== 0)
            writer.tag(8, WireType.Varint).int32(message.events_with_items);
        /* bool email_sent = 9 [json_name = "email_sent"]; */
        if (message.email_sent !== false)
            writer.tag(9, WireType.Varint).bool(message.email_sent);
        /* string email_error = 10 [json_name = "email_error"]; */
        if (message.email_error !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.email_error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.SubmitResponse
 */
export const SubmitResponse = new SubmitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewResponse$Type extends MessageType<PreviewResponse> {
    constructor() {
        super("brandguardfeedback.PreviewResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FeedbackItem },
            { no: 2, name: "total_issues", kind: "scalar", localName: "total_issues", jsonName: "total_issues", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "error_count", kind: "scalar", localName: "error_count", jsonName: "error_count", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "warning_count", kind: "scalar", localName: "warning_count", jsonName: "warning_count", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PreviewResponse>): PreviewResponse {
        const message = { items: [], total_issues: 0, error_count: 0, warning_count: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PreviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PreviewResponse): PreviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguardfeedback.FeedbackItem items */ 1:
                    message.items.push(FeedbackItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_issues = 2 [json_name = "total_issues"];*/ 2:
                    message.total_issues = reader.int32();
                    break;
                case /* int32 error_count = 3 [json_name = "error_count"];*/ 3:
                    message.error_count = reader.int32();
                    break;
                case /* int32 warning_count = 4 [json_name = "warning_count"];*/ 4:
                    message.warning_count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PreviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguardfeedback.FeedbackItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            FeedbackItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_issues = 2 [json_name = "total_issues"]; */
        if (message.total_issues !== 0)
            writer.tag(2, WireType.Varint).int32(message.total_issues);
        /* int32 error_count = 3 [json_name = "error_count"]; */
        if (message.error_count !== 0)
            writer.tag(3, WireType.Varint).int32(message.error_count);
        /* int32 warning_count = 4 [json_name = "warning_count"]; */
        if (message.warning_count !== 0)
            writer.tag(4, WireType.Varint).int32(message.warning_count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.PreviewResponse
 */
export const PreviewResponse = new PreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeedbackLogEntry$Type extends MessageType<FeedbackLogEntry> {
    constructor() {
        super("brandguardfeedback.FeedbackLogEntry", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "submission_id", kind: "scalar", localName: "submission_id", jsonName: "submission_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "event_id", kind: "scalar", localName: "event_id", jsonName: "event_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "event_type", kind: "scalar", localName: "event_type", jsonName: "event_type", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "type", kind: "enum", T: () => ["brandguardfeedback.ModelType", ModelType] },
            { no: 6, name: "severity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "item_description", kind: "scalar", localName: "item_description", jsonName: "item_description", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FeedbackLogEntry>): FeedbackLogEntry {
        const message = { id: "", submission_id: "", event_id: "", event_type: "", type: 0, severity: "", item_description: "", created_at: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedbackLogEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedbackLogEntry): FeedbackLogEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string submission_id = 2 [json_name = "submission_id"];*/ 2:
                    message.submission_id = reader.string();
                    break;
                case /* string event_id = 3 [json_name = "event_id"];*/ 3:
                    message.event_id = reader.string();
                    break;
                case /* string event_type = 4 [json_name = "event_type"];*/ 4:
                    message.event_type = reader.string();
                    break;
                case /* brandguardfeedback.ModelType type */ 5:
                    message.type = reader.int32();
                    break;
                case /* string severity */ 6:
                    message.severity = reader.string();
                    break;
                case /* string item_description = 7 [json_name = "item_description"];*/ 7:
                    message.item_description = reader.string();
                    break;
                case /* string created_at = 8 [json_name = "created_at"];*/ 8:
                    message.created_at = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedbackLogEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string submission_id = 2 [json_name = "submission_id"]; */
        if (message.submission_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.submission_id);
        /* string event_id = 3 [json_name = "event_id"]; */
        if (message.event_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.event_id);
        /* string event_type = 4 [json_name = "event_type"]; */
        if (message.event_type !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.event_type);
        /* brandguardfeedback.ModelType type = 5; */
        if (message.type !== 0)
            writer.tag(5, WireType.Varint).int32(message.type);
        /* string severity = 6; */
        if (message.severity !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.severity);
        /* string item_description = 7 [json_name = "item_description"]; */
        if (message.item_description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.item_description);
        /* string created_at = 8 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.created_at);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.FeedbackLogEntry
 */
export const FeedbackLogEntry = new FeedbackLogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeedbackHistoryItem$Type extends MessageType<FeedbackHistoryItem> {
    constructor() {
        super("brandguardfeedback.FeedbackHistoryItem", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "severity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FeedbackHistoryItem>): FeedbackHistoryItem {
        const message = { type: "", severity: "", description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedbackHistoryItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedbackHistoryItem): FeedbackHistoryItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* string severity */ 2:
                    message.severity = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedbackHistoryItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* string severity = 2; */
        if (message.severity !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.severity);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.FeedbackHistoryItem
 */
export const FeedbackHistoryItem = new FeedbackHistoryItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeedbackHistorySubmission$Type extends MessageType<FeedbackHistorySubmission> {
    constructor() {
        super("brandguardfeedback.FeedbackHistorySubmission", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_type", kind: "scalar", localName: "event_type", jsonName: "event_type", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_action", kind: "scalar", localName: "client_action", jsonName: "client_action", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "submitter_id", kind: "scalar", localName: "submitter_id", jsonName: "submitter_id", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "submitter_display", kind: "scalar", localName: "submitter_display", jsonName: "submitter_display", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "submitter_email", kind: "scalar", localName: "submitter_email", jsonName: "submitter_email", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "email_sent", kind: "scalar", localName: "email_sent", jsonName: "email_sent", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "email_error", kind: "scalar", localName: "email_error", jsonName: "email_error", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FeedbackHistoryItem }
        ]);
    }
    create(value?: PartialMessage<FeedbackHistorySubmission>): FeedbackHistorySubmission {
        const message = { id: "", event_type: "", client_action: "", comment: "", submitter_id: "", submitter_display: "", submitter_email: "", created_at: "", email_sent: false, email_error: "", items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedbackHistorySubmission>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedbackHistorySubmission): FeedbackHistorySubmission {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string event_type = 2 [json_name = "event_type"];*/ 2:
                    message.event_type = reader.string();
                    break;
                case /* string client_action = 3 [json_name = "client_action"];*/ 3:
                    message.client_action = reader.string();
                    break;
                case /* string comment */ 4:
                    message.comment = reader.string();
                    break;
                case /* string submitter_id = 5 [json_name = "submitter_id"];*/ 5:
                    message.submitter_id = reader.string();
                    break;
                case /* string submitter_display = 6 [json_name = "submitter_display"];*/ 6:
                    message.submitter_display = reader.string();
                    break;
                case /* string submitter_email = 7 [json_name = "submitter_email"];*/ 7:
                    message.submitter_email = reader.string();
                    break;
                case /* string created_at = 8 [json_name = "created_at"];*/ 8:
                    message.created_at = reader.string();
                    break;
                case /* bool email_sent = 9 [json_name = "email_sent"];*/ 9:
                    message.email_sent = reader.bool();
                    break;
                case /* string email_error = 10 [json_name = "email_error"];*/ 10:
                    message.email_error = reader.string();
                    break;
                case /* repeated brandguardfeedback.FeedbackHistoryItem items */ 11:
                    message.items.push(FeedbackHistoryItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedbackHistorySubmission, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string event_type = 2 [json_name = "event_type"]; */
        if (message.event_type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.event_type);
        /* string client_action = 3 [json_name = "client_action"]; */
        if (message.client_action !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.client_action);
        /* string comment = 4; */
        if (message.comment !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.comment);
        /* string submitter_id = 5 [json_name = "submitter_id"]; */
        if (message.submitter_id !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.submitter_id);
        /* string submitter_display = 6 [json_name = "submitter_display"]; */
        if (message.submitter_display !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.submitter_display);
        /* string submitter_email = 7 [json_name = "submitter_email"]; */
        if (message.submitter_email !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.submitter_email);
        /* string created_at = 8 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.created_at);
        /* bool email_sent = 9 [json_name = "email_sent"]; */
        if (message.email_sent !== false)
            writer.tag(9, WireType.Varint).bool(message.email_sent);
        /* string email_error = 10 [json_name = "email_error"]; */
        if (message.email_error !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.email_error);
        /* repeated brandguardfeedback.FeedbackHistoryItem items = 11; */
        for (let i = 0; i < message.items.length; i++)
            FeedbackHistoryItem.internalBinaryWrite(message.items[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.FeedbackHistorySubmission
 */
export const FeedbackHistorySubmission = new FeedbackHistorySubmission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeedbackHistoryResponse$Type extends MessageType<FeedbackHistoryResponse> {
    constructor() {
        super("brandguardfeedback.FeedbackHistoryResponse", [
            { no: 1, name: "submissions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FeedbackHistorySubmission }
        ]);
    }
    create(value?: PartialMessage<FeedbackHistoryResponse>): FeedbackHistoryResponse {
        const message = { submissions: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedbackHistoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedbackHistoryResponse): FeedbackHistoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguardfeedback.FeedbackHistorySubmission submissions */ 1:
                    message.submissions.push(FeedbackHistorySubmission.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedbackHistoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguardfeedback.FeedbackHistorySubmission submissions = 1; */
        for (let i = 0; i < message.submissions.length; i++)
            FeedbackHistorySubmission.internalBinaryWrite(message.submissions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.FeedbackHistoryResponse
 */
export const FeedbackHistoryResponse = new FeedbackHistoryResponse$Type();
